import React, { useState } from 'react';
import axios from '../../axiosConfig';
import '../../styles/InviteOwnerModal.css';

const InviteOwnerModal = ({ isOpen, onClose }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Reset states when modal closes
    const handleClose = () => {
        setEmail('');
        setError('');
        setSuccess('');
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        setIsSubmitting(true);

        try {
            const response = await axios.post('/api/v1/auth/invite/owner', { email }, {
                headers: { Authorization: `Bearer ${localStorage.getItem('jwt')}` },
            });

            const invitationToken = response.data; // Token from backend
            setSuccess('Zaproszenie wysłane pomyślnie!');

            // Show success message and close after delay
            setTimeout(() => {
                handleClose();
            }, 3000);

        } catch (err) {
            setError('Wysłanie zaproszenia nie powiodło się. Proszę spróbować ponownie.');
        } finally {
            setIsSubmitting(false);
        }
    };

    // Don't render anything if modal is not open
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h2>Zaproś właściciela</h2>
                </div>

                <form className="invite-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            id="email"
                            type="email"
                            placeholder="Adres email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    {error && <p className="error-message">{error}</p>}
                    {success && <p className="success-message">{success}</p>}

                    <div className="form-actions">
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={handleClose}
                        >
                            Anuluj
                        </button>
                        <button
                            type="submit"
                            className="submit-button"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Wysyłanie...' : 'Zaproś'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default InviteOwnerModal;